import { FacebookReviewsService } from '@weave/schema-gen-ts/dist/schemas/reviews/facebook-reviews/v1/reviews_facebook.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaFacebookReviewsV1Service = bindHTTP(FacebookReviewsService);
export const serviceName = 'facebook-reviews-v1' as const;
